<div id="parkPointsMap" #parkPointsMap class="mapa" style="height: 380px;"></div>
